<template>
  <line-chart :load="loadChartData" />
</template>

<script>
import LineChart from "@/components/LineChart";

export default {
  name: "StatUsers",
  components: { LineChart },
  methods: {
    async loadChartData(filters) {
      return await this.axios.form("base:/api/admin/stat/users", filters);
    },
  },
};
</script>

<style lang="scss" scoped></style>
